import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types';
const SalesOrderContext = createContext()


const SalesOrderProvider = ({children}) => {
    const [expanded, setExpanded] = useState(true);
    const [expandedDriver, setExpandedDriver] = useState(false)
    const [isOpenModal, setOpenModal] = useState(true)
    const [filterData, setFilteredData] = useState(null)
    const [invoiceActived, setInvoiceActived] = useState(null)
    const [selectedDriver, setSelectedDriver] = useState(null)
    const [selectedUnity, setSelectedUnity] = useState(null)
    const [refreshFn, setRefreshFn] = useState(()=>()=>{})
    const registerRefresh = useCallback((fn)=>setRefreshFn(()=>fn),[])
     const onClick =useCallback(()=>{
            setExpanded(false)
            setExpandedDriver(true)
        },[])
        const onCancelDriver = useCallback(()=>{
            setExpanded(true)
            setExpandedDriver(false)
        },[])
        const onClose = useCallback(()=>{
            setOpenModal(false)
            setExpandedDriver(false)
            setExpanded(true)
            setInvoiceActived((prev => prev ? { ...prev, isChecked: false } : null))
            refreshFn?.()
           
        },[refreshFn])
    const toggleModal = useCallback(()=>{
        setOpenModal(false)
        setExpanded(true)
        setInvoiceActived({})
        setExpandedDriver(false)
    },[])
  const value = useMemo(() => ({
    expanded,
    isOpenModal,
    expandedDriver,
    filterData,
    invoiceActived,
    selectedDriver,
    selectedUnity,
    setSelectedUnity,
    setSelectedDriver,
    setInvoiceActived,
    setFilteredData,
    setOpenModal,
    onClick,
    toggleModal,
    onCancelDriver,
    onClose,
    setExpandedDriver,
    setExpanded,
    registerRefresh, 
  }), [expanded, expandedDriver,isOpenModal,filterData,invoiceActived,selectedDriver,selectedUnity,setFilteredData,setOpenModal, onClick, onCancelDriver, onClose, registerRefresh, toggleModal]);

  return (
    <SalesOrderContext.Provider value={value}>
      {children}
    </SalesOrderContext.Provider>
  )
}

const useSalesOrder=()=>{
    const context = useContext(SalesOrderContext)
    if(context === undefined) throw new Error("This component is outside from the sales order provider.")
    return context
}
SalesOrderProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export {SalesOrderProvider, useSalesOrder}
